import Resource from '@/api/resource';
import request from '@/utils/request';

class OfferResource extends Resource {
  constructor() {
    super('admin/offers');
  }

  changeStatus(slug, status, note) {
    return request({
      url: '/' + this.uri + '/' + slug + '?status=' + status,
      method: 'patch',
      data: { note: note },
    });
  }

  changePackage(slug, status, note) {
    return request({
      url: '/' + this.uri + '/' + slug + '?subscription=' + status,
      method: 'patch',
      data: { note: note },
    });
  }
  
  update(slug, resource) {
    return request({
      url: '/' + this.uri + '/' + slug,
      method: 'post',
      data: resource,
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }

  delayedDelete(slug) {
    return request({
      url: '/' + this.uri + '/' + slug + '?delayedDelete=6',
      method: 'patch',
      data: { note: null },
    });
  }

  getBillingInfo(slug) {
    return request({
      url: '/' + this.uri + '/' + slug + '/billing',
      method: 'get',
    });
  }

  activateWithPayment(slug) {
    return request({
      url: '/' + this.uri + '/' + slug + '/activate-with-payment',
      method: 'post',
    });
  }

  bulkActivate(slugs) {
    return request({
      url: '/' + this.uri + '/bulk-activate',
      method: 'post',
      data: { slugs },
    });
  }
}

export { OfferResource as default };
